import UtilityBar from '../components/UtilityBar/UtilityBar';
import LiveBand from '../components/LiveBand/LiveBand';
import Navigation from '../components/Navigation/Navigation';
import asajNavigation from '../components/Navigation/navigationReducer';
import LookFooter from '../components/Look/LookFooter';

export default function install(config) {
  // Live meet and next meet, from asaj.site's live-status expander
  config.settings.apiExpanders = [
    ...config.settings.apiExpanders,
    { match: '', GET_CONTENT: ['live-status'] },
  ];

  config.registerSlotComponent({
    slot: 'aboveHeader',
    name: 'AsajUtilityBar',
    component: UtilityBar,
  });
  config.registerSlotComponent({
    slot: 'belowHeader',
    name: 'AsajLiveBand',
    component: LiveBand,
  });

  config.registerSlotComponent({
    slot: 'postFooter',
    name: 'AsajLookFooter',
    component: LookFooter,
  });

  // The utility bar has Log in; VLT's own login link would repeat it
  // (getSlotComponent throws when it's missing, so check the slot's names)
  const headerTools = config.slots.headerTools?.slots ?? [];
  if (headerTools.includes('Anontools')) {
    config.unRegisterSlotComponent('headerTools', 'Anontools', 0);
  }

  // Desktop tabs with dropdowns, and the same menu in the phone drawer, both
  // from components/Navigation/menu.js
  config.registerUtility({
    name: 'asaj',
    type: 'navigation',
    method: Navigation,
  });
  config.settings.vlt.components.navigation = 'asaj';
  config.addonReducers = {
    ...config.addonReducers,
    navigation: asajNavigation,
  };

  return config;
}
